import { render, staticRenderFns } from "./GvdAssignResourcesToPage.modal.vue?vue&type=template&id=95018942"
import script from "./GvdAssignResourcesToPage.modal.vue?vue&type=script&lang=ts"
export * from "./GvdAssignResourcesToPage.modal.vue?vue&type=script&lang=ts"
import style0 from "./GvdAssignResourcesToPage.modal.vue?vue&type=style&index=0&id=95018942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports